import Link from 'next/link';


// card component will be used in tools

export default function Card({ 
    title, items, info, length, 
    resultCountMessage, ips, 
    ip, 
    maximumLengthMessage}) {

    return (
        <div className="border-1 bg-color-grey border-radius"
            style={{ overflow: "hidden" }}>
            <div className="card-body p-2 p-lg-4">
                <h4 className="card-title my-md-3 my-2 font-weight-bold text-secondary line-height-3 d-flex"
                    style={{ justifyContent: "space-between" }}>
                    <span> {title} ({ips}) </span>
                    {length > 100 && <span> {resultCountMessage} : {length}</span>}

                </h4>
                {info && <p className="text-4 line-height-3"> {info.split('&')[0]} <span className="font-weight-bold">
                    {ips}({ip}) </span> {info.split('&')[1]}</p>}
                {length > 100 && <p className="text-4 line-height-3 text-muted"> {maximumLengthMessage.split('&')[0]} {length} {maximumLengthMessage.split('&')[1]}</p>}
                <table className="table table-hover">
                    <tbody>
                        {items.map((item, i) => {
                            if (item.name) {
                                if (i < 10) {
                                    return (
                                        <tr key={item.name} className="line-height-3">
                                            <td className="py-1 text-4 font-weight-bold"> {item.name} </td>
                                            {item.name && <td className="py-1"> : </td>}
                                            <td className="py-1 text-4" style={{ wordWrap: "break-word" }}>
                                                {item.value}
                                            </td>
                                        </tr>
                                    )
                                }
                            } else {
                                return (
                                    <tr key={item}>
                                        <td className="py-1 text-4 line-height-3">
                                            <Link
                                                href={{
                                                    pathname: `http://${item}`,
                                                }} passHref>
                                                <a target="_blank"
                                                    className="text-color-primary">{item}
                                                </a>
                                            </Link>
                                        </td>
                                    </tr>
                                )
                            }
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
